var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 6.87378V33.1262C39.9986 34.9483 39.2715 36.6953 37.9784 37.984C36.6853 39.2726 34.9317 39.9977 33.1026 40H25.6662V24.3429H30.627L31.9922 18.4906H25.6662V13.4743H30.4866L31.8289 7.69681H26.0712C24.5278 7.69699 23.0476 8.30781 21.9562 9.39492C20.8649 10.482 20.2517 11.9564 20.2515 13.4938V18.4906H17.2796L15.9177 24.3429H20.2515V40H6.89745C5.06828 39.9977 3.31474 39.2726 2.02162 37.984C0.728506 36.6953 0.00145085 34.9483 0 33.1262V6.87378C0.0014543 5.05175 0.728511 3.30471 2.02163 2.01603C3.31474 0.727357 5.06828 0.00231112 6.89745 0H33.1026C34.9317 0.00231112 36.6853 0.727357 37.9784 2.01603C39.2715 3.30471 39.9985 5.05175 40 6.87378Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.324325da5f99f0b69cd7f60e5009d3f1.svg";
export { ForwardRef as ReactComponent };